/* eslint-disable no-unused-vars */
import { handleApiRequest } from '../services/transports';

import { REACT_APP_DAO_DOMAIN } from './base';

export const offersList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/offers-list`,
  method: 'get',
  query
});
export const offer = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/offers-details/${id}`,
  method: 'get'
});

export const offersRespondList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/offers-respond-list`,
  method: 'get',
  query
});


export const SOPoffersList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-list`,
  method: 'get',
  query
});

export const sopOffersRejectResponse = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-reject-response`,
  method: 'post',
  data
});

export const sopDemandsCreateEscalatedRespond = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-create-escalated-respond`,
  method: 'post',
  data
});

export const sopOffersAcceptResponse = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-accept-response`,
  method: 'post',
  data
});

export const sopAddOffer = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-create`,
  method: 'post',
  data
});
export const sopOffersDeleteRespond = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-delete-respond/${id}`,
  method: 'post'
});
export const sopEditOffer = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-edit`,
  method: 'put',
  data
});
export const sopOffersCreateRespond = form => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-create-respond`,
  method: 'post',
  form
});
export const sopOffersRespondList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-offers-respond-list`,
  method: 'get',
  query
});

export const demandsList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/demands-list`,
  method: 'get',
  query
});
export const demandsRespondList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/demands-respond-list`,
  method: 'get',
  query
});

export const escalationReasonsList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Escalation/escalation-reasons`,
  method: 'get',
  query
});

export const replyEscalationReasonList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Escalation/escalation-responses `,
  method: 'get',
  query
});

export const createEscalation = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Escalation/create`,
  method: 'post',
  data
});

export const replayEscalation = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Escalation/reply`,
  method: 'post',
  data
});

export const getReplayEscalation = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Escalation/reply/${id}`,
  method: 'get',
  id
});

export const detailsEscalation = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Escalation/escalation-history/${id}`,
  method: 'get',
  id
});

export const assignEscalation = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Escalation/assign-user`,
  method: 'post',
  data
});

export const demand = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/demands-details/${id}`,
  method: 'get'
});


export const sopDemandsList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-list`,
  method: 'get',
  query
});

export const getDemandStatuses = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-response-types`,
  method: 'get'
});

export const sopDemand = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-details/${id}`,
  method: 'get'
});
export const sopDemandsDeleteRespond = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-delete-respond/${data.id}`,
  data: { comment: data.comment },
  method: 'post'
});

export const sopDemandsClose = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-close/${id}`,
  method: 'post'
});

export const sopDemandsComplete = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-complete`,
  method: 'post',
  data
});

export const sopDemandEdit = form => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-edit`,
  method: 'put',
  form
});

export const SOPAddDemandRequest = form => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-create`,
  method: 'post',
  form
});

export const sopDemandToOffer = form => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-create-respond`,
  method: 'post',
  form
});


export const sopDemandsResponseList = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-responses-list`,
  method: 'get',
  query
});

export const sopDemandsRejectResponse = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-reject-response`,
  method: 'post',
  data
});


export const sopDemandsAcceptResponse = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-accept-response`,
  method: 'post',
  data
});

export const sopNewOfferDemandsAcceptResponse = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-accept-escalated-response`,
  method: 'post',
  data
});

export const demandHistory = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/demand-history/${id}`,
  method: 'get'
});

export const demandOperationHistory = id => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/demand-operation-history/${id}`,
  method: 'get'
});

export const ChatUsers = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Chat/GetChatUsers`,
  method: 'get',
  query
});

export const MPChatUsers = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Chat/GetMPChatUsers`,
  method: 'get',
  query
});

export const LoadOldMessages = room => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Chat/LoadOldMessages/${room}`,
  method: 'get'
});

export const SetUnreadMessages = room => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Chat/SetUnreadMessages/${room}`,
  method: 'get'
});

export const GetCompanyId = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Chat/GetCompanyId`,
  method: 'get'
});

export const UploadFile = data => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Chat/upload-attachment`,
  method: 'post',
  data
});

export const GetDemandIdListSOP = demandType => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/sop-demands-Id-list/${demandType}`,
  method: 'get'
});

export const GetDemandIdListMP = () => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Management/mp-demands-Id-list`,
  method: 'get'
});
export const searchAlternativeDrug = query => handleApiRequest({
  path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/Portal/Management/search-alternative-drug`,
  method: 'get',
  query
});

export const redistribution = {
  sop: {
    listDemand: query => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-list-demand`,
      method: 'get',
      query
    }),
    getDemand: (id, query) => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-get-demand/${id}`,
      method: 'get',
      query
    }),
    sendFromDemandList: id => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-send-from-demand-list/${id}`,
      method: 'post'
    }),
    createDemand: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-create-demand`,
      method: 'post',
      data
    }),
    editDemand: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-edit-demand`,
      method: 'put',
      data
    }),
    cancelDemand: id => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-cancel-demand/${id}`,
      method: 'put'
    }),
    completeDemand: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-complete-demand`,
      method: 'put',
      data
    }),
    listOffer: (id, query) => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-list-offers/${id}`,
      method: 'get',
      query
    }),
    acceptOffers: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-accept-offers`,
      method: 'post',
      data
    }),
    rejectOffers: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-reject-offers`,
      method: 'post',
      data
    }),
    createOffer: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-create-offer`,
      method: 'post',
      data
    }),
    unavailabilityOffer: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-unavailability-offer`,
      method: 'post',
      data
    }),
    cancelOffer: data => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/sop-cancel-offer`,
      method: 'put',
      data
    })
  },
  mp: {
    listDemand: query => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/mp-list-demand`,
      method: 'get',
      query
    }),
    getDemand: (id, query) => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/mp-get-demand/${id}`,
      method: 'get',
      query
    }),
    listOffer: (id, query) => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/mp-list-offers/${id}`,
      method: 'get',
      query
    }),
    getHistory: id => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/mp-demand-history/${id}`,
      method: 'get'
    })
  },
  listStatus: () => handleApiRequest({
    path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/demand-status`,
    method: 'get'
  }),
  drugAlternatives: (id, query) => handleApiRequest({
    path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Redistribution/drug-alternatives/${id}`,
    method: 'get',
    query
  })
};

export const drug = {
  mp: {
    activeStock: query => handleApiRequest({
      path: `${REACT_APP_DAO_DOMAIN}demand-and-offer-service/api/portal/Drug/mp-active-stock`,
      method: 'get',
      query
    })
  }
};
